import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const TimeErrorView = props => {
  const {
    initialValues,
    onSubmit,
    loading,
    onBack,
    languageData,
    goToReservationDate,
    goToReservationTime,
  } = props;
  return (
    <FlexContainer className="flex-column padlr10 justify-start items-center bgGradientBlue fontWhite height-550px">
      <FlexContainer
        className="flex-column  justify-center text-center margt120 padlr30 row-gap-1 pad30 marglr14 borderrad38"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Label
          className={
            'text-26 margtb20   align-items-center justify-center text-center'
          }
        >
          {languageData === 'EN' ? (
            <>
              You haven't set <br /> your start your time
            </>
          ) : (
            'No has configurado tu hora de inicio'
          )}
        </Label>
        <Label className="text-16 text-center width100 fontWhite">
          {languageData === 'EN' ? (
            <React.Fragment>Please choose your start time</React.Fragment>
          ) : (
            <React.Fragment>Por favor, elige el horario</React.Fragment>
          )}
        </Label>
        <FlexContainer className={'flex-column margt30 padlr10  padtb10'}>
          <Button
            sx={{
              py: 0.4,
              px: 0.6,
              color: 'white',
              textTransform: 'none',
              fontSize: '18px',
              fontWeight: 'normal',
              border: '2px solid rgba(255,255,255,0.2)',
              backgroundColor: 'rgba(249, 133, 196,0.5)',
              borderRadius: '20px',
              '&:disabled': { opacity: 0.7 },
              '&:hover': {
                backgroundColor: 'rgba(249, 133, 196, 0.7)',
              },
            }}
            type="button"
            onClick={goToReservationTime}
            disabled={loading}
          >
            {loading
              ? languageData === 'EN'
                ? 'Loading...'
                : 'Cargando...'
              : languageData === 'EN'
              ? 'Select a time'
              : 'Seleccione un horario'}
          </Button>
        </FlexContainer>
        <FlexContainer className={'flex-column padlr10 margb30 '}>
          <Button
            sx={{
              py: 0.4,
              px: 0.6,
              color: 'white',
              textTransform: 'none',
              fontSize: '18px',
              fontWeight: 'normal',
              border: '2px solid rgba(255,255,255,0.2)',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '20px',
              '&:disabled': { opacity: 0.7 },
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
            type="button"
            onClick={goToReservationDate}
            disabled={loading}
          >
            {loading
              ? languageData === 'EN'
                ? 'Loading...'
                : 'Cargando...'
              : languageData === 'EN'
              ? 'Go back to date selector'
              : 'Volver al selector de fechas'}
          </Button>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default TimeErrorView;
